import React from "react";
import Navbar from "./Navbar";

import idk from "../assets/graph.svg";
import Recommended from "./Recommended";
import InvestCard from "./InvestCard";

function Profile({ user }) {
  let data = [
    { id: 1, topic: "Risk", count: "45" },
    { id: 2, topic: "Age", count: "19" },
    { id: 3, topic: "Economic Factor", count: "19" },
  ];

  let props = [
    {
      topic: "Risk",
      count: "45",
      subtitle: "1 (safest) - 100 (riskiest)",
    },
    {
      topic: "Economic Factor",
      count: "19",
      subtitle: "Unemployment, inflation, and political stability",
    },
    { topic: "Age", count: "19" },
  ];

  function doCalculations() {
    var risk = document.getElementById("input1").value;
    var econ = document.getElementById("input1").value;
    var age = document.getElementById("input1").value;
    // console.log(typeof parseInt(age));
    var cal = (parseInt(risk) + parseInt(econ) + parseInt(age)) / 3;
    localStorage.setItem("answer", cal);
    console.log(localStorage);

    document
      .getElementById("wow")
      .setAttribute("class", "col-start-2 delay-150");
  }

  return (
    <div className="h-screen overflow-hidden">
      <Navbar />
      <div className="w-full flex flex-col justify-center items-center overflow-hidden ">
        <div className="text-[#73C4FC] text-5xl m-4 mt-5 font-bold ">
          Welcome {user?.displayName}
        </div>
        <div className="grid lg:grid-cols-2 gap-x-16 gap-y-8">
          <div className="flex flex-col items-center justify-items-center w-80 h-36 rounded-3xl border-2 border-black">
            <div className="text-3xl font-bold py-3">{props[0].topic}</div>
            <div>
              <input
                type="text"
                id="input1"
                class="text-lg border-b-2 border-black bg-white text-center text-6xl text-gray-900 rounded-sm text-[#004380] w-full"
              />
            </div>
            {props[0].subtitle && (
              <div className="text-sm font-bold text-center">
                {props[0].subtitle}
              </div>
            )}
          </div>

          <div className="flex flex-col items-center justify-items-center w-80 h-36 rounded-3xl border-2 border-black">
            <div className="text-3xl font-bold py-3">{props[1].topic}</div>
            <div>
              <input
                type="text"
                id="input2"
                class="text-lg border-b-2 border-black bg-white text-center text-6xl text-gray-900 rounded-sm text-[#004380] w-full"
              />
            </div>
            {props[1].subtitle && (
              <div className="text-sm font-bold text-center">
                {props[1].subtitle}
              </div>
            )}
          </div>

          <div>
            <img src={idk} className="absolute h-2/5 w-2/5 bottom-16 left-36" />
          </div>

          <div className="flex flex-col items-center justify-items-center w-80 h-36 rounded-3xl border-2 border-black">
            <div className="text-3xl font-bold py-3">{props[2].topic}</div>
            <div>
              <input
                type="text"
                id="input3"
                class="text-lg border-b-2 border-black bg-white text-center text-6xl text-gray-900 rounded-sm text-[#004380] w-full"
              />
            </div>
            {props[2].subtitle && (
              <div className="text-sm font-bold text-center">
                {props[2].subtitle}
              </div>
            )}
          </div>

          <button
            className="text-xl px-4 py-2 leading-none rounded-lg col-start-2 w-[50%] ml-[30%] mt-[5%] text-2xl text-white border-white  bg-[#73C4FC] whitespace-nowrap	mx-2 "
            onClick={doCalculations}
          >
            Save
          </button>

          <div id="wow" className="col-start-2 hidden">
            Saved!
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
